/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cleardraft1Inputs */

const en_cleardraft1 = /** @type {(inputs: Cleardraft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Draft`)
};

const de_cleardraft1 = /** @type {(inputs: Cleardraft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf löschen`)
};

/**
* | output |
* | --- |
* | "Clear Draft" |
*
* @param {Cleardraft1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cleardraft1 = /** @type {((inputs?: Cleardraft1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cleardraft1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cleardraft1(inputs)
	return de_cleardraft1(inputs)
});
export { cleardraft1 as "clearDraft" }